import React, {useState} from 'react';
import {Button, Form, OverlayTrigger, Popover, Spinner} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose, faFilter} from "@fortawesome/free-solid-svg-icons";

interface IFilterPopoverProps {
    id: string;
    title: string;
    isLoading: boolean;
    onApplyFilter: (event: React.FormEvent) => void;
    children: React.ReactNode;
    t: (key: string) => string;
}

export const FilterPopover: React.FC<IFilterPopoverProps> = ({
                                                                 id,
                                                                 title,
                                                                 isLoading,
                                                                 onApplyFilter,
                                                                 children,
                                                                 t
                                                             }) => {
    const [isShow, setIsShow] = useState<boolean>(false);

    const handleClickSubmit = (event: React.FormEvent) => {
        setIsShow(false);
        event.preventDefault();
        onApplyFilter(event);
    }

    return (
        <OverlayTrigger show={isShow} trigger="click" placement="bottom" overlay={
        <Popover id={id}>
            <Popover.Header as="h3" className="d-flex flex-row justify-content-between">
                <div>{title}</div>
                <FontAwesomeIcon className="pointer-hover" onClick={() => setIsShow(false)} icon={faClose}/>
            </Popover.Header>
            <Popover.Body>
                <Form onSubmit={handleClickSubmit}>
                    {children}
                    <div className="text-center mt-3">
                        <Button variant="secondary" type="submit" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status"
                                             aria-hidden="true"/>
                                    {' '}{t("DropZone.loading")}
                                </>
                            ) : (
                                t("Filter.Apply")
                            )}
                        </Button>
                    </div>
                </Form>
            </Popover.Body>
        </Popover>
    } rootClose>
            <Button size="sm" variant="secondary" onClick={() => setIsShow(true)}>
            <FontAwesomeIcon
                icon={faFilter}
            />
        </Button>
    </OverlayTrigger>
    )
}
